import React, { useState } from 'react';
import { User, Lock, ArrowRight, Mail, Phone, MapPin, Calendar, AlertCircle, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { ListenInsteadOfReading } from '../components/ListenInsteadOfReading';
export function LoginRegister() {
  const [activeTab, setActiveTab] = useState<'login' | 'register'>('login');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1500);
  };
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-1221" data-mp="3ttjcnwd762l6">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1222" data-mp="3ouoijy9s4rlr">
        {/* Page Header */}
        <div className="text-center mb-8" data-id="element-1223" data-mp="7mb6wsyd7tom">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1224" data-mp="7n2t5d62of28">
            Student Portal
          </h1>
          <p className="text-lg text-gray-600" data-id="element-1225" data-mp="2ln9npjjmgly">
            Access your on-demand classes or register to create an account
          </p>
        </div>

        {/* Important Notice */}
        <div className="mb-8 p-4 bg-blue-50 border-2 border-blue-200 rounded-xl flex items-start gap-3 max-w-2xl mx-auto" data-id="element-1226" data-mp="3d9om38fs9two">
          <AlertCircle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-1227" data-mp="3hd36ebar8wfx" />
          <div data-id="element-1228" data-mp="3mb4niqomelor">
            <p className="text-sm font-semibold text-blue-900 mb-1" data-id="element-1229" data-mp="3m7gt7pbcpv8z">
              For On-Demand Classes Only
            </p>
            <p className="text-sm text-blue-800" data-id="element-1230" data-mp="2d3g27p0bt2">
              This registration is for <strong data-id="element-1231" data-mp="a8d3ronshh">On-Demand Classes only</strong>.
              If you're taking Zoom or In-Person classes, you do not need to
              register here.
            </p>
          </div>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-8" data-id="element-1232" data-mp="dujjzperckt1">
          <div className="inline-flex bg-white rounded-lg shadow-sm border border-gray-200 p-1" data-id="element-1233" data-mp="drx492hpqyzq">
            <button onClick={() => setActiveTab('login')} className={`px-8 py-3 rounded-md font-semibold transition-all ${activeTab === 'login' ? 'bg-brand-purple-600 text-white shadow-md' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1234" data-mp="ir09oo1lv788">
              Log In
            </button>
            <button onClick={() => setActiveTab('register')} className={`px-8 py-3 rounded-md font-semibold transition-all ${activeTab === 'register' ? 'bg-brand-purple-600 text-white shadow-md' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1235" data-mp="2onvo14571pvu">
              Register
            </button>
          </div>
        </div>

        {/* Login Form */}
        {activeTab === 'login' && <Card className="max-w-md mx-auto p-8" data-id="element-1236" data-mp="32m3dys3tbqxi">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-1237" data-mp="32md3yfouxy37">
              Log In to Your Account
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1238" data-mp="187sochfe8sqo">
              <div data-id="element-1239" data-mp="189dkgbhcwjqn">
                <label htmlFor="login-username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1240" data-mp="189wznkfmgu0z">
                  Username
                </label>
                <div className="relative" data-id="element-1241" data-mp="3a5cnclcbjpmk">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1242" data-mp="3a4bdgk71h96f">
                    <User className="h-5 w-5 text-gray-400" data-id="element-1243" data-mp="3f34ps9alau50" />
                  </div>
                  <input type="text" id="login-username" className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" placeholder="Enter your username" required data-id="element-1244" data-mp="314eqcn0asidh" />
                </div>
              </div>

              <div data-id="element-1245" data-mp="pg6pnmtfyo6u">
                <label htmlFor="login-password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1246" data-mp="pfx183o1op39">
                  Password
                </label>
                <div className="relative" data-id="element-1247" data-mp="2qf8zdebdkkwa">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1248" data-mp="2mf8cd5a7n1dm">
                    <Lock className="h-5 w-5 text-gray-400" data-id="element-1249" data-mp="2hfvpikjc9ub1" />
                  </div>
                  <input type="password" id="login-password" className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" placeholder="••••••••" required data-id="element-1250" data-mp="2chu2joislaua" />
                </div>
              </div>

              <Button type="submit" className="w-full font-semibold" size="lg" isLoading={isLoading} data-id="element-1251" data-mp="1trm6trhf9mo4">
                Log In <ArrowRight className="ml-2 h-4 w-4" data-id="element-1252" data-mp="1jt6g3pmb4ff5" />
              </Button>
            </form>

            <div className="mt-6 text-center" data-id="element-1253" data-mp="19ozpghm1t1fz">
              <a href="/14.html" className="text-sm text-gray-600 hover:text-brand-purple-600 hover:underline" data-id="element-1254" data-mp="19o6knm6ngm0h">
                Forgot your password?
              </a>
            </div>
          </Card>}

        {/* Registration Form */}
        {activeTab === 'register' && <Card className="max-w-2xl mx-auto p-8" data-id="element-1255" data-mp="1ojw8lpveb97u">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-1256" data-mp="qzjcuvx39ij7">
              Create Your Account
            </h2>
            <p className="text-sm text-gray-600 mb-6 text-center" data-id="element-1257" data-mp="vxun37rapv1y">
              Register for on-demand classes
            </p>

            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1258" data-mp="15ne8ak2he0zz">
              {/* Personal Information */}
              <div data-id="element-1259" data-mp="888nij70hdtf">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-1260" data-mp="88s5u10kq47z">
                  <User className="w-5 h-5 mr-2 text-brand-purple-600" data-id="element-1261" data-mp="d6a8xarwtp82" />
                  Personal Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1262" data-mp="54t6es308w3u">
                  <div data-id="element-1263" data-mp="82mturzrido">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1264" data-mp="6rls2pxkoq9">
                      Title
                    </label>
                    <select className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1265" data-mp="9x42tkyjdzrn">
                      <option data-id="element-1266" data-mp="3if09cju0t4df">Mr.</option>
                      <option data-id="element-1267" data-mp="3decjw2lfwvlb">Ms.</option>
                      <option data-id="element-1268" data-mp="3dfdwwcm0ns5o">Mrs.</option>
                      <option data-id="element-1269" data-mp="3satuusppw87c">Dr.</option>
                    </select>
                  </div>
                  <div data-id="element-1270" data-mp="3nc0hd0afkh76">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1271" data-mp="3nbr0q3b9zme5">
                      First Name<span className="text-red-500" data-id="element-1272" data-mp="17kcu5wl7y31k">*</span>
                    </label>
                    <input type="text" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1273" data-mp="12m1kpmyu5ujv" />
                  </div>
                  <div data-id="element-1274" data-mp="114w07sgbb5tt">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1275" data-mp="115nsatapalfc">
                      Last Name<span className="text-red-500" data-id="element-1276" data-mp="1579225rxujlb">*</span>
                    </label>
                    <input type="text" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1277" data-mp="1sva8n95k3py3" />
                  </div>
                  <div data-id="element-1278" data-mp="1o4a9dx8ysvsf">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1279" data-mp="1o3r0f61alhqj">
                      Company
                    </label>
                    <input type="text" className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1280" data-mp="2glcu36eytxnq" />
                  </div>
                </div>
              </div>

              {/* Billing Address */}
              <div data-id="element-1281" data-mp="1i5p0q4ncsdk1">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-1282" data-mp="1i56wakqjet11">
                  <MapPin className="w-5 h-5 mr-2 text-brand-purple-600" data-id="element-1283" data-mp="1d7drnw4vu72v" />
                  Billing Address
                </h3>
                <div className="space-y-4" data-id="element-1284" data-mp="2ar8eotzcbr2p">
                  <div data-id="element-1285" data-mp="25vjbmgo43s1n">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1286" data-mp="25v1ab5mlenmv">
                      Address 1<span className="text-red-500" data-id="element-1287" data-mp="20ttzsyt2faci">*</span>
                    </label>
                    <input type="text" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1288" data-mp="1vviqcp6on1ut" />
                  </div>
                  <div data-id="element-1289" data-mp="2w5tg2mumb24z">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1290" data-mp="2w2ffnk5il306">
                      Address 2
                    </label>
                    <input type="text" className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1291" data-mp="3626dnvtaa050" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1292" data-mp="3fuu8wm4m7w1m">
                    <div data-id="element-1293" data-mp="3js9si1pu2rkf">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1294" data-mp="3ot65d4s5xo1z">
                        City<span className="text-red-500" data-id="element-1295" data-mp="3orczhrpdj7v1">*</span>
                      </label>
                      <input type="text" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1296" data-mp="3tq68p7xmocpe" />
                    </div>
                    <div data-id="element-1297" data-mp="3heykurmzqn7i">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1298" data-mp="3he6o3dhnqjfn">
                        State/Province<span className="text-red-500" data-id="element-1299" data-mp="3mdtbugv43i2p">*</span>
                      </label>
                      <select required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1300" data-mp="3qg67udk241ma">
                        <option value="" data-id="element-1301" data-mp="46ddhmtxt99x">Select...</option>
                        <option value="AZ" data-id="element-1302" data-mp="907sicyll02o">Arizona</option>
                        <option value="CA" data-id="element-1303" data-mp="dy9n9v5dyntz">California</option>
                        <option value="NV" data-id="element-1304" data-mp="dxq64gnk83h0">Nevada</option>
                      </select>
                    </div>
                    <div data-id="element-1305" data-mp="i1o1cg9rku4s">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1306" data-mp="myxsc0csxduq">
                        Zip<span className="text-red-500" data-id="element-1307" data-mp="mwlenze2tpnh">*</span>
                      </label>
                      <input type="text" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1308" data-mp="27em2rpzo6icm" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div data-id="element-1309" data-mp="2m64rcc6lhl7l">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-1310" data-mp="2m5mmws9s40ol">
                  <Phone className="w-5 h-5 mr-2 text-brand-purple-600" data-id="element-1311" data-mp="2hemsbto4tup9" />
                  Contact Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1312" data-mp="2cfjvgwib2usd">
                  <div data-id="element-1313" data-mp="39vp9isuxceft">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1314" data-mp="39x0dotsa7o7g">
                      Phone<span className="text-red-500" data-id="element-1315" data-mp="353yw2e0oxak6">*</span>
                    </label>
                    <input type="tel" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1316" data-mp="3o20ock2v3wu8" />
                  </div>
                  <div data-id="element-1317" data-mp="3j97krzj4qujq">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1318" data-mp="3j8po51sk2eba">
                      Email<span className="text-red-500" data-id="element-1319" data-mp="358wsqt6339wz">*</span>
                    </label>
                    <input type="email" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1320" data-mp="3aads2k8x6obg" />
                  </div>
                </div>
              </div>

              {/* Additional Information */}
              <div data-id="element-1321" data-mp="ykbemt0y48bt">
                <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1322" data-mp="yji6bnmc9ark">
                  Additional Information
                </h3>
                <div className="space-y-4" data-id="element-1323" data-mp="2izq4jaljfxve">
                  <div data-id="element-1324" data-mp="2f1iiq1c7w6dc">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1325" data-mp="2f2buxhty3o2v">
                      How did you hear about us?
                    </label>
                    <select className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1326" data-mp="2o0x8eykk8cws">
                      <option value="" data-id="element-1327" data-mp="2xqyxntong1da">Select...</option>
                      <option data-id="element-1328" data-mp="2xqgro5c6q8s6">Google Search</option>
                      <option data-id="element-1329" data-mp="3bqhtbn09xk8p">Social Media</option>
                      <option data-id="element-1330" data-mp="3bq84w3uvnl54">Referral</option>
                      <option data-id="element-1331" data-mp="36rwu9qwrd6lu">Other</option>
                    </select>
                  </div>
                  <div data-id="element-1332" data-mp="1hcgvn5ggn3a7">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1333" data-mp="1hbxgfwi72szv">
                      Are you on Facebook?
                    </label>
                    <select className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1334" data-mp="1cg09ggstmyzr">
                      <option value="" data-id="element-1335" data-mp="1isb8uq6by24e">Select...</option>
                      <option data-id="element-1336" data-mp="1nsh56jnjocst">Yes</option>
                      <option data-id="element-1337" data-mp="1nts5ualp14fp">No</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Username & Password */}
              <div data-id="element-1338" data-mp="v5crzreass5y">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-1339" data-mp="v5w8r4s7paie">
                  <Lock className="w-5 h-5 mr-2 text-brand-purple-600" data-id="element-1340" data-mp="103xtdu5adhvz" />
                  Create Your Username & Password
                </h3>
                <div className="space-y-4" data-id="element-1341" data-mp="19t7n1efs38m7">
                  <div data-id="element-1342" data-mp="19tzjssl43ce2">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1343" data-mp="19uisrjssaqfy">
                      Username<span className="text-red-500" data-id="element-1344" data-mp="cdjzrz71zaza">*</span>
                    </label>
                    <input type="text" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1345" data-mp="hbc1tm1ewdh7" />
                  </div>
                  <div data-id="element-1346" data-mp="3vz134u7u5qc5">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1347" data-mp="3w2f541cl7xj2">
                      Password<span className="text-red-500" data-id="element-1348" data-mp="3r3low15x1sf7">*</span>
                    </label>
                    <input type="password" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1349" data-mp="3n18mnmqdocn6" />
                    <p className="text-xs text-gray-500 mt-1" data-id="element-1350" data-mp="38ccd1l8oarkg">
                      Must be at least 8 characters
                    </p>
                  </div>
                  <div data-id="element-1351" data-mp="2z9tehdbx7140">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1352" data-mp="2zbea769z0q3g">
                      Confirm Password<span className="text-red-500" data-id="element-1353" data-mp="2oo6m0ehtu4a5">*</span>
                    </label>
                    <input type="password" required className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1354" data-mp="2tokpdj8hgq1u" />
                  </div>
                </div>
              </div>

              {/* License Expiration Date */}
              <div data-id="element-1355" data-mp="3cf26eqjydx7d">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-1356" data-mp="3cdiq4zyarm5l">
                  <Calendar className="w-5 h-5 mr-2 text-brand-purple-600" data-id="element-1357" data-mp="2ymclyqk2p0cd" />
                  License Expiration Date
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1358" data-mp="33ke0cy6k0bhi">
                  <div data-id="element-1359" data-mp="3rb1lil5hcxm0">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1360" data-mp="3rarvixkfqqgb">
                      Month
                    </label>
                    <select className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1361" data-mp="9bz2tk6huhcq">
                      <option data-id="element-1362" data-mp="58j66nufch01">January</option>
                      <option data-id="element-1363" data-mp="j2a6r6q6gqjm">February</option>
                      <option data-id="element-1364" data-mp="j44qwitmkemn">March</option>
                      <option data-id="element-1365" data-mp="e2fh16i52705">April</option>
                      <option data-id="element-1366" data-mp="e3pfhwswlh7b">May</option>
                      <option data-id="element-1367" data-mp="3mih7p5h7k9op">June</option>
                      <option data-id="element-1368" data-mp="3mjio7pgztodt">July</option>
                      <option data-id="element-1369" data-mp="3ih5gwwmlliex">August</option>
                      <option data-id="element-1370" data-mp="3ii71brpi7h9b">September</option>
                      <option data-id="element-1371" data-mp="3iji4bpb4kkzd">October</option>
                      <option data-id="element-1372" data-mp="cka0e2utup2">November</option>
                      <option data-id="element-1373" data-mp="969lbdr3vk9">December</option>
                    </select>
                  </div>
                  <div data-id="element-1374" data-mp="3rk6n0xbgr9il">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1375" data-mp="1bqftu04permm">
                      Year
                    </label>
                    <select className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" data-id="element-1376" data-mp="16qtg7pkyr9da">
                      <option data-id="element-1377" data-mp="358n4e23z3un2">2024</option>
                      <option data-id="element-1378" data-mp="359oeo4d60d3q">2025</option>
                      <option data-id="element-1379" data-mp="3a7zpahbaarn0">2026</option>
                      <option data-id="element-1380" data-mp="3a6yf0f23e96c">2027</option>
                    </select>
                  </div>
                </div>
                <p className="text-xs text-blue-600 mt-2" data-id="element-1381" data-mp="3f1az8rbe7oj5">
                  <a href="#" className="hover:underline" data-id="element-1382" data-mp="3jx9hrya1icbn">
                    Click here to obtain your license expiration date from ADRE
                  </a>
                </p>
              </div>

              {/* Identity Confirmation */}
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-1383" data-mp="3swwi0gr19c34">
                <div className="flex items-start" data-id="element-1384" data-mp="1s6b494fds94">
                  <input type="checkbox" id="identity-confirm" required className="mt-1 h-4 w-4 text-brand-purple-600 focus:ring-brand-purple-500 border-gray-300 rounded" data-id="element-1385" data-mp="1ylhso11xpenw" />
                  <label htmlFor="identity-confirm" className="ml-3 text-sm text-gray-700" data-id="element-1386" data-mp="1w2d3o8xgiuuc">
                    <strong data-id="element-1387" data-mp="1mbs5gmlp3sby">I affirm this information to be true.</strong> The
                    Arizona Department of Real Estate requires that we confirm
                    your information and that you are the person taking the
                    classes. Incorporating a real person's name and license
                    number into a registration without the permission of both
                    parties, if you are NOT the person named in the
                    registration, we strongly recommend that you log out and not
                    continue. We reserve the right to use reasonable means to
                    verify your identity.
                  </label>
                </div>
              </div>

              {/* Privacy Statement */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1388" data-mp="3m13xbokarchs">
                <h4 className="font-semibold text-blue-900 mb-2" data-id="element-1389" data-mp="3m38cj2nnbxxd">
                  Privacy Statement
                </h4>
                <p className="text-sm text-blue-800 mb-2" data-id="element-1390" data-mp="3cbawnilp0hsb">
                  By registering with Desert Sage Seminars, you will create an
                  account by which we can administer your real estate license
                  renewal classes. Your information will be kept confidential
                  and not shared with any other party.
                </p>
                <p className="text-sm text-blue-800 mb-2" data-id="element-1391" data-mp="3to75hta0a03">
                  The Arizona Department of Real Estate requires that we confirm
                  your information and that you are the person taking the
                  classes.
                </p>
                <p className="text-sm text-blue-800" data-id="element-1392" data-mp="2klfzx0vi9ptm">
                  Payments for our classes are made through a 3rd party merchant
                  account secured by our site, and they do not share your credit
                  card information with us or any other party.
                </p>
              </div>

              {/* Submit Button */}
              <Button type="submit" className="w-full font-semibold" size="lg" isLoading={isLoading} data-id="element-1393" data-mp="143z4o1ngdekt">
                Create Account <CheckCircle2 className="ml-2 h-5 w-5" data-id="element-1394" data-mp="1dtr171f44hrx" />
              </Button>
            </form>
          </Card>}

        <ListenInsteadOfReading data-id="element-1395" data-mp="1isbyot2zcnco" />
      </div>
    </div>;
}